var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.isIM)?_c('span',{staticClass:"im fa-stack"},[_c('i',{staticClass:"fas fa-comment-alt fa-stack-2x im-icon",style:({ color: `${_vm.colorStyle.backgroundColor} !important` })}),_vm._v(" "),_c('span',{staticClass:"fa-stack-1x fa-inverse mb-5 im-text",style:({ color: _vm.colorStyle.color + ' !important' })},[_vm._v("\n      "+_vm._s(_vm.initial))])]):_c('span',{staticClass:"author-initial",style:({
      color: _vm.colorStyle.color + ' !important',
      backgroundColor: _vm.colorStyle.backgroundColor + '!important',
    })},[_vm._v(_vm._s(_vm.initial))])])
}
var staticRenderFns = []

export { render, staticRenderFns }